import type {
  ImportStakeholderAnswersResult,
  StakeholderAnswer,
} from "../../hooks";

/**
 * 取り込み前の確認文言。
 *
 * 取り込みは要約シートの現在の内容で上書きするため、取り込み済みが対象に含まれることを
 * 件数で伝える。全件が取り込み済みのときに「うち」と言うと部分集合に読めてしまうので分ける。
 */
export function buildImportConfirmMessage(
  stakeholderAnswers: readonly StakeholderAnswer[],
  answerIds: readonly string[],
): string {
  const importedCount = stakeholderAnswers.filter(
    (answer) =>
      answerIds.includes(answer.answerId) && answer.importedAnswerCount > 0,
  ).length;

  if (importedCount === 0) {
    return `${answerIds.length}件を取り込みますか？`;
  }
  if (importedCount === answerIds.length) {
    return `${answerIds.length}件を取り込みます。すべて要約シートの内容で上書きされます。よろしいですか？`;
  }
  return `${answerIds.length}件を取り込みます。うち取り込み済みの${importedCount}件は要約シートの内容で上書きされます。よろしいですか？`;
}

/** 取り込み後の結果文言。失敗は回答ごとに理由が違うので、件数だけでなく理由も並べる */
export function buildImportResultMessage(
  result: ImportStakeholderAnswersResult,
): string {
  const failureReasons = result.results
    .filter((item) => !item.success)
    .map((item) => `・${item.errorMessage ?? "原因不明"}`);
  return [
    `取り込み成功: ${result.successCount}件`,
    `取り込み失敗: ${result.failureCount}件`,
    ...failureReasons,
  ].join("\n");
}
